import { queryKeys } from "../queryKeys";
import type { Product } from "../rest/account";
import { type AccessKey, getAccessKeys } from "../rest/authx";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetAccessKeys = ({
  accountID,
  product,
  options,
}: {
  accountID?: string;
  product?: Product;
  options?: QueryOptions<AccessKey[]>;
}) => {
  const { data, ...rest } = useRequest(
    queryKeys.accounts.accessKeys(accountID || "", product),
    () => getAccessKeys({ accountID, product }),
    {
      ...options,
      gcTime: 1000 * 60 * 5,
    },
  );

  return { access_keys: data || [], ...rest };
};
